<template>
  <div class="header">
    <div class="container h-100">
      <div class="row h-100 justify-content-center align-items-center">
        <div class="col-sm-18 col-md-4">
          <div class="header-content">
            <h1 class="header-title">
              WeiWei Shop
            </h1>
            <p>
              歡迎來到WeiWei Shop
            </p>
            <div class="header-btn mt-3">
              <button @click="goabout" class="btn custom-btn btn-info mr-4">
                關於我
              </button>
              <button @click="goproducts" class="btn custom-btn btn-info mr-4">
                瀏覽商品
              </button>
            </div>
          </div>
        </div>
        <div class="col-sm-13 col-md-5 m-4">
          <div class="graphic">
            <img src="/img/layout/taiwan.jpg" alt="" width="300">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Header",
  props: {
    msg: String
  },
  methods:{
    goabout(){
      this.$router.replace('about');
    },
    goproducts(){
      this.$router.replace('products');
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.header{
  padding-top: 7rem;
  width: 100%;
  min-height: 500px;
  text-align: left;
  background-color:darkgoldenrod;
}
</style>
